import {
    InventoryLocationInteraction,
    InventoryLocationInteractionMode
} from "./interaction";
import {
    drawInventoryLocationStyle,
    inventoryLocationBeatersLineStyle
} from "../../../../map/styles/inventory-locations";
import {EpInventoryLocations} from "../../../../map/layers/inventory-locations";
import {Collection, Feature} from "ol";
import * as turf from "@turf/turf";
import {getLength} from "ol/sphere";
import {Point} from "ol/geom";
import {fromLonLat, toLonLat} from "ol/proj";

export class InventoryLocationInteractionBeatersLine extends InventoryLocationInteraction {
    /**
     * @param {InventoryLocationInteractionsHandler} handler
     */
    constructor(handler) {
        const layer = new EpInventoryLocations(handler.epMap.map);
        layer.farStyle = null;
        layer.name = 'interaction_beaters_line';
        layer.title = 'Obszary - linie naganki'

        handler.epMap.addCustomLayer(layer)

        super('beaters_line', handler, layer);

        this.dictionary = {
            [InventoryLocationInteractionMode.DRAW]: 'Rysuj linię naganki',
            [InventoryLocationInteractionMode.EDIT]: 'Edytuj linię naganki',
            deleteConfirm: 'Czy na pewno chcesz usunąć linię naganki?',
        };

        this.createFeatureFromInput('LineString', inventoryLocationBeatersLineStyle);
        this.updateSpots();
        this.updateLengthInfo();

        $('input[name="beaters_count"]').change(() => {
            this.updateSpots();
        })
    }

    draw() {
        super.draw();
        let that = this;

        this.handler.epMap.helpTooltip.set('Aby zakończyć rysowanie linii, kliknij drugi raz w miejsce ostatniego punktu');

        this.addOlInteraction(
            this.epLayer.addDraw({
                noSource: true,
                style: drawInventoryLocationStyle,
                type: 'LineString',
                condition: (e) => {
                    let features = this.handler.epMap.getOlMap().getFeaturesAtPixel(e.pixel, {
                        layerFilter: (layer) => {
                            return layer === this.handler.epMap.boundaries.getLayer();
                        }
                    });
                    return features.length > 0;
                },
                end: function (e) {
                    that.addFeature(e.feature);
                    that.handler.setCurrentInteraction(null);

                    e.feature.setStyle(inventoryLocationBeatersLineStyle)
                }
            })
        )
    }

    edit() {
        super.edit();

        let that = this;
        let previousCoordinates = this.features[0].getGeometry().getCoordinates();

        this.addOlInteraction(
            this.epLayer.addEdit({
                style: drawInventoryLocationStyle,
                features: new Collection(this.features),
                end: function (e) {
                    let feature = e.features.item(0);

                    if (
                        !turf.booleanWithin(
                            turf.lineString(feature.getGeometry().getCoordinates()),
                            that.handler.epMap.boundaries.getBufferedBoundariesPolygon(2)
                        )
                    ) {
                        feature.getGeometry().setCoordinates(previousCoordinates);
                        return;
                    }

                    that.updateFeature(feature);
                    that.updateSpots();
                    that.updateLengthInfo();
                    previousCoordinates = feature.getGeometry().getCoordinates();
                }
            })
        )
    }

    end(forced) {
        this.updateSpots();
        this.updateLengthInfo();

        super.end(forced);
    }

    updateLengthInfo() {
        let length = 0;
        if(this.features.length) {
            length = getLength(this.features[0].getGeometry()).toFixed(2);
        }

        $('.beaters_line_length').text(length + 'm')
    }

    updateSpots() {
        // Clear old features
        let features = this.epLayer.getSource().getFeatures().filter(feature => feature.get('type') === 'beater');
        for (let feature of features) {
            this.epLayer.getSource().removeFeature(feature);
        }

        let beatersCount = $('input[name="beaters_count"]').val();
        if (
            !beatersCount ||
            !this.getInput().val().length ||
            beatersCount.length === 0 ||
            parseInt(beatersCount) <= 1
        ) {
            return;
        }

        let points = this.getInput().val().split(" ");
        let coordinatesArray = points.map(coord => coord.split(",").map(a => parseFloat(a)));
        let line = turf.lineString(coordinatesArray);

        let length = turf.length(line, {units: 'meters'})
        let chunkLength = length / (parseInt(beatersCount) - 1);

        let chunks = turf.lineChunk(line, chunkLength, {units: 'meters'})

        features = [];
        let i = 1;
        for (let line of chunks.features) {
            let feature = new Feature({
                geometry: new Point(fromLonLat([line.geometry.coordinates[0][0], line.geometry.coordinates[0][1]])),
            })
            feature.setStyle(inventoryLocationBeatersLineStyle)
            feature.set('type', 'beater')
            feature.set('name', String(i));
            features = [...features, feature]

            i++
        }

        let feature = new Feature({
            geometry: new Point(fromLonLat([line.geometry.coordinates[line.geometry.coordinates.length - 1][0], line.geometry.coordinates[line.geometry.coordinates.length - 1][1]])),
        })
        feature.setStyle(inventoryLocationBeatersLineStyle)
        feature.set('type', 'beater')
        feature.set('name', String(i));
        features = [...features, feature]

        let coordinates = '';
        for (let feature of features) {
            coordinates += ' ' + toLonLat(feature.getGeometry().getCoordinates()).join(',');
        }
        $('input[name="beaters_spots"]').val(coordinates);

        this.epLayer.getSource().addFeatures(features);

        $('.beaters_distance').text((length / (parseInt(beatersCount) - 1)).toFixed(2) + 'm');
    }

    onDelete(id) {
        super.onDelete(id);

        let features = this.epLayer.getSource().getFeatures().filter(feature => feature.get('type') === 'beater');
        for (let feature of features) {
            this.epLayer.getSource().removeFeature(feature);
        }
    }
}